// Import dependencies
import React from 'react';
import cookie from 'js-cookie';
import queryString from 'query-string';
import axios from 'axios';

// Import components
import LoadingSpinner from '../../../reusables/spinner';

// Import configuration from .json file
import config from '../../../../configs/config.json';
const AUTH_URL = config.AUTH_URL;

class ResetPasswordPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            memberId: '',
            verificationCode: '',
            credentials: {
                password1: '',
                password2: ''
            },
            status: {
                invalidPassword: false,
                memberIdInvalid: false,
                codeExpired: false,
                codeInvalid: false,
                passwordReset: false
            },
            message: '',
            loading: false,
            error: false
        }
    }

    componentDidMount() {
        // When the component (screen) mounts, check cooke if user is already logged in

        var token = cookie.get('token');
        // var user_type = cookie.get('user-type');

        if (token) {
            console.log("Token detected, logging out user..");
            cookie.remove('user-type', { path: '/' });
            cookie.remove('token', { path: '/' });
        }

        // Obtain query parameters from URL
        var { code, mid } = queryString.parse(this.props.location.search, { ignoreQueryPrefix: true });

        // If there is no code or member id specified in the query parameters,
        // the user has no business being here, re-direct them to the home page
        if (!code || !mid) {
            window.location.href = '/';
        }

        this.setState({ memberId: mid, verificationCode: code });
    }

    updateForm = (field) => (event) => {
        // Handle user input within form
        var newValue = event.target.value;
        var credentials = this.state;
        credentials[field] = newValue;
        this.setState({ credentials });
    }


    handlePasswordSubmit = () => {
        var status = this.state.status;
        if (this.state.credentials.password1 === '' && this.state.credentials.password2 === '') {
            status['invalidPassword'] = true;
            this.setState({ status, message: 'Password cannot be empty.' });
        }
        else if (this.state.credentials.password1 === this.state.credentials.password2) {
            status['invalidPassword'] = false;
            this.setState({ status });

            axios.post(`${AUTH_URL}/reset`, { code: this.state.verificationCode, newPassword: this.state.credentials.password1, id: this.state.memberId })
                .then(response => {
                    var data = response.data;
                    console.log(data);

                    if (data.success) {
                        status.passwordReset = true;
                        this.setState({ status });
                    } else {
                        status.linkInvalid = true;
                        this.setState({ status });
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.setState({ loading: false, error: true });
                })
        } else {
            status['invalidPassword'] = true;
            this.setState({ status, message: 'Passwords do not match.' });
        }
    }



    render() {
        if (this.state.error) {
            return (
                <div className="alert alert-danger">
                    Server error, try again!
                </div>
            );
        } else if (this.state.status.passwordReset) {
            return (
                <div className='alert alert-success'>
                    <p>Password successfully reset.</p>
                    <a href='/'>Login</a>
                </div>
            )
        } else if (this.state.status.linkInvalid) {
            return (
                <div className='alert alert-danger'>
                    <p>Link is invalid or expired.</p>
                    <a href='/'>Back</a>
                </div>
            )
        } else if (this.state.loading) {
            return (
                <LoadingSpinner message='Resetting email, please wait..' />
            );
        } else if (this.state.status.codeExpired) {
            return (
                <div className='alert alert-danger'>
                    This email verification link has expired. <br />
                    Contact OLLI @ UCI to generate a new link.
                </div>
            )
        } else if (this.state.status.codeInvalid) {
            return (
                <div className='alert alert-danger'>
                    This activation link is invalid. Please click the link from the most recent email from us.
                </div>
            )
        } else {
            return (
                <div className='container-fluid'>
                    <div className='card'>

                        <div className='card-body'>
                            <h2 className='card-title'>Password Reset</h2>

                            <label htmlFor='#passwordInput'>New video password</label>
                            <input className={(this.state.status.invalidPassword) ? 'form-control is-invalid' : 'form-control'} id='passwordInput' type='password' value={this.state.password1} onChange={this.updateForm('password1')} />

                            <label style={{ marginTop: 15 }} htmlFor='#confirmPasswordInput'>Confirm new video password</label>
                            <input className={(this.state.status.invalidPassword) ? 'form-control is-invalid' : 'form-control'} id='confirmPasswordInput' type='password' value={this.state.password2} onChange={this.updateForm('password2')} />

                            {(this.state.message) ? <div style={{ marginTop: 15 }} className={(this.state.success) ? 'alert alert-success' : 'alert alert-danger'} id='messageBox'><p>{this.state.message}</p></div> : ''}

                            <div style={{ textAlign: 'center' }}>
                                <button style={{ marginTop: 15 }} className='btn btn-primary' onClick={this.handlePasswordSubmit}>Reset Password</button>
                            </div>



                        </div>
                    </div>
                </div>
            )
        }
    }
}

export default ResetPasswordPage;